import { addSlashes, withCompanyPrefix } from "@/routes/route.utils";
import type { DOCUMENT_TEMPLATE_TYPE } from "@/types/(company)/document-template.interface";

// ─── Path segments ────────────────────────────────────────────────────────────

export const TEMPLATES_ID_KEY = "templateId";

// ─── Builder navigation state ─────────────────────────────────────────────────
// Passed via React Router `state` when opening the builder from the Studio
// Documents flow. All fields are optional and applied ONCE on first load, then
// cleared (replace) so a refresh doesn't re-apply them.
export interface DocumentBuilderNavState {
  /** Seed the editor with a predefined starter's content on first load. */
  starterType?: DOCUMENT_TEMPLATE_TYPE;
  /** Auto-run AI generation with this prompt on first load. */
  aiPrompt?: string;
  /**
   * Where the builder was opened from — drives origin-aware exit/back
   * navigation. "studio" returns to the Studio Documents flow; "settings"
   * (or absent) returns to the Settings › Templates table.
   */
  from?: "studio" | "settings";
}

export enum COMPANY_TEMPLATES_PATH_SEGMENTS {
  SETTINGS_ROOT = "settings",
  ROOT = "templates",
  DETAILS = `:${TEMPLATES_ID_KEY}`,
  SIGN = "sign",
}

// Settings page lives inside Layout; builder lives outside Layout for a full
// screen experience. The Templates tab is a real route segment (not a query
// param), so returning from the builder lands directly on that tab.
export const COMPANY_TEMPLATES_PATHS = Object.freeze({
  LIST: withCompanyPrefix(
    addSlashes(
      COMPANY_TEMPLATES_PATH_SEGMENTS.SETTINGS_ROOT,
      "document-templates",
    ),
  ),
  EDIT: (id: string | number) =>
    withCompanyPrefix(
      addSlashes(
        COMPANY_TEMPLATES_PATH_SEGMENTS.SETTINGS_ROOT,
        COMPANY_TEMPLATES_PATH_SEGMENTS.ROOT,
        String(id),
      ),
    ),
  SIGN: (id: string | number) =>
    withCompanyPrefix(
      addSlashes(
        COMPANY_TEMPLATES_PATH_SEGMENTS.SETTINGS_ROOT,
        COMPANY_TEMPLATES_PATH_SEGMENTS.ROOT,
        String(id),
        COMPANY_TEMPLATES_PATH_SEGMENTS.SIGN,
      ),
    ),
});
